import { FC } from 'react';
import {
  IntegrationSettingsEntryInputType,
  IntegrationSettingsTypedInputProps,
} from 'modules/integrationSettings/types';
import { StringInput } from './StringInput';
import { IntegerInput } from './IntegerInput';
import { OptionSetInput } from './OptionSetInput';
import { BooleanInput } from './BooleanInput';

export const IntegrationSettingsTypedInput = ({
  integrationSettingsEntry,
  dataKey,
}: IntegrationSettingsTypedInputProps) => {
  const componentsByType: Record<IntegrationSettingsEntryInputType, FC<IntegrationSettingsTypedInputProps>> = {
    [IntegrationSettingsEntryInputType.String]: StringInput,
    [IntegrationSettingsEntryInputType.Integer]: IntegerInput,
    [IntegrationSettingsEntryInputType.OptionSet]: OptionSetInput,
    [IntegrationSettingsEntryInputType.Boolean]: BooleanInput,
  };

  const Component = componentsByType[integrationSettingsEntry.type];

  return <Component integrationSettingsEntry={integrationSettingsEntry} dataKey={dataKey} />;
};
